/**
 * Config Store (Zustand)
 * Manages AI configuration: model selection, temperature, thinking budget, etc.
 * Extracted from App.tsx.
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { PromptConfig } from '../types';

export const DEFAULT_SYSTEM_PROMPT = "You are an elite financial translator specialized in Vietnamese stock market regulations and IFRS. Translate annual reports with high precision. IMPORTANT: You are provided with a list of sentences. You must translate each one individually and return them in the exact same list order.";
export const DEFAULT_RULES = "";

interface ConfigState {
    config: PromptConfig;

    // Actions
    setConfig: (config: Partial<PromptConfig>) => void;
    applyPreset: (preset: { thinking: number; tokens: number; temp: number }) => void;
    resetConfig: () => void;
}

const defaultConfig: PromptConfig = {
    systemInstruction: DEFAULT_SYSTEM_PROMPT,
    extraRules: DEFAULT_RULES,
    model: 'gemini-3.1-flash-lite',
    auditModel: 'gemini-3.1-flash-lite',
    temperature: 0.1,
    topP: 0.95,
    topK: 40,
    maxOutputTokens: 65536,
    thinkingBudget: 0,
    autoQC: false,
};

export const useConfigStore = create<ConfigState>()(
    persist(
        (set) => ({
            config: defaultConfig,

            setConfig: (updates) => set(state => ({
                config: { ...state.config, ...updates }
            })),

            applyPreset: (preset) => set(state => ({
                config: {
                    ...state.config,
                    thinkingBudget: preset.thinking,
                    maxOutputTokens: preset.tokens,
                    temperature: preset.temp
                }
            })),

            resetConfig: () => set({ config: defaultConfig })
        }),
        {
            name: 'trans-bctn-config-store',
            storage: createJSONStorage(() => localStorage)
        }
    )
);

// Preset definitions (can be used by UI)
export const PRESETS = [
    { id: 'fast', name: 'Speed (Flash)', thinking: 0, tokens: 65536, temp: 0.1 },
    { id: 'balanced', name: 'Balanced', thinking: 0, tokens: 65536, temp: 0.1 },
    { id: 'deep', name: 'Deep Reasoning', thinking: 0, tokens: 65536, temp: 0.1 }
];
